<template>
  <CommonPages id="detail" classs="detail ">
    <div :class="`cover-banner cover-banner-${deviceType} cover-banner-${domainConfig.BGNUM}`" />
    <section class="detail-container">
      <div class="page-head-row">
        <div class="page-head">
          {{ domainConfig.IAmTitle }}
        </div>
        <AdComponent v-if="deviceType == 'mobile'" ref="ads-detail-1"
        class="ads-insert pc_padding padding-horizon-24" :ads="adsensConfig?.detail_1"
        :showDebug="showDebug" />
        <div class="page-head-slish" />
        <div v-if="wikiInfo" class="page-head-sub-head">
          {{ wikiInfo.summary }}
        </div>
      </div>

      <AdComponent v-if="deviceType != 'mobile'" ref="ads-detail-1"
        class="ads-insert pc_padding padding-horizon-24" :ads="adsensConfig?.detail_1"
        :showDebug="showDebug" />

      <div class="common-body-container">
        <div class="common-content-row">
          <img v-if="wikiInfo" :src="wikiInfo.imgUrl" class="common-content-img" alt="">
          <AdComponent v-if="deviceType == 'mobile'" ref="ads-detail-2" class="ads-insert pc_padding "
            :ads="adsensConfig?.detail_2" :showDebug="showDebug" />
          <div v-if="wikiInfo" class="common-content-title">
            {{ wikiInfo.title }}
          </div>
          <div v-if="wikiInfo" class="common-content" v-html="wikiInfo.description" />
          <div class="common-slish" />

          <div class="discover-container">
            <AdComponent v-if="deviceType == 'mobile'" ref="ads-detail-3" class="ads-insert pc_padding "
            :ads="adsensConfig?.detail_3" :showDebug="showDebug" />
            <div class="discover-title">
              Discover More
            </div>
            <div class="discover-row">
              <template v-for="(data,i) in wikiList">
                <div :key="`list_item_${i}`" class="discover-item"
                  @click="chooseWiki(data.id,data.title,data.category)">
                  <div class="discover-img">
                    <img :src="data.thumbnailImgUrl" alt="">
                  </div>
                  <div class="discover-item-cotext">
                    <div class="discover-title">
                      {{ data.title }}
                    </div>
                    <div class="discover-btn-row">
                      Read More <img src="@/assets/icon-arrow.png" alt="">
                    </div>
                  </div>
                </div>
                <AdComponent v-if="shouldInsertAd(i) !== -1 && deviceType == 'mobile' && adsensConfig?.detail_recommand?.[shouldInsertAd(i)]"
                  :key="`ad_${i}`" :ref="'ads-detail-card' + i" class="ads-insert  "
                  :ads="adsensConfig?.detail_recommand?.[shouldInsertAd(i)]"
                  :showDebug="showDebug" />
              </template>
            </div>
          </div>
        </div>
        <div class="home-tags-row">
          <div class="tags-title">
            Tags
          </div>
          <div class="tag-row">
            <div v-for="(data,i) in tagList" :key="`tag_${i}`" class="tags-item cursor"
              :class="{'active':activeTag == data}" @click="chooseTag(data)">
              {{ data }}
            </div>
          </div>
        </div>
      </div>
    </section>
  </CommonPages>
</template>

<script>
import common from '@/mixin/common.js';
import adMixin from '@/mixin/adMixin.js';
import adTrackingMixin from '@/mixin/adTrackingMixin.js';
import { mapGetters } from 'vuex';
import AdComponent from '@/pages/components/AdComponent.vue'
import CommonPages from '@/pages/components/pc_common.vue'

import '@/css/home.scss'

export default {
  name: 'Home',
  components: {
    AdComponent,
    CommonPages,
  },
  mixins: [common, adMixin, adTrackingMixin],
  data () {
    return {
      wikiList: [],
      tagList: [],

      page: 1,   // 当前页数
      hasNext: false,
      activeTag: null,
      wikiInfo: null,

      ////////
      activeTitle: '',
      activeId: null
    };
  },
  metaInfo () {
    return {
      title: `${this.activeTitle.replace(/-/g, ' ')} | ${this.domainConfig['meta'].title}`,
      meta: [
        {
          name: 'description',
          content: `${this.domainConfig['meta'].des}`,
        },
      ],
    };
  },
  computed: {
    ...mapGetters([
      "adsensConfig",
      'adPosConfig',
    ])
  },
  created () {
    const { id, title, cat } = this.$route.params
    console.log(`id:${id} cat:${cat}`);
    this.activeTitle = title.replace(/-/g, ' ');
    this.activeId = id
    this.activeTag = cat.replace(/-/g, ' ');
    console.log(this.activeTag);
  },
  async activated () {
    console.log(`${this.$options.name} Component activated-----------`);
  },
  async mounted () {
    console.log(`-------------------${this.$options.name} mounted`)
    console.log(this.domainConfig['type']);
    this.getTagList()
    this.getWiki()
    await this.getWikiList()
    // this.loadAdSenseScript();  // 重新加载广告脚本 - 已被 adMixin 接管
    // this.watchForIframeInsertion() - 已被 adTrackingMixin 接管

    // 使用防抖包装滚动事件
    this.onScroll = this.debounce(this.onScroll.bind(this), 300);
    // 监听滚动事件
    window.addEventListener('scroll', this.onScroll);

    // 在页面ready后执行showPos方法
    this.$nextTick(() => {
      setTimeout(() => {
        this.showPos();
      }, 1000); // 延迟1秒执行，确保页面元素已完全加载
    });
  },
  deactivated () {
    console.log(`${this.$options.name} Component deactivated-----------`);
  },
  beforeDestroy () {
    console.log(`-------------------${this.$options.name} beforeDestroy`);
    // 组件销毁时移除滚动事件监听
    window.removeEventListener('scroll', this.onScroll);
  },
  methods: {
    //客户端监听 - 已被 adTrackingMixin 接管
    //shuju
    async getTagList () {
      try {
        const res = await this.$global.server.getTagList({ type: this.domainConfig['IAmType'] })
        console.log(res)
        if (res.code == 200) {
          let data = res.data
          this.tagList.push(...data)
        }
      } catch (err) {
        console.log(err)
      }
    },
    async getWiki () {
      const params = {
        id: this.activeId
      };

      try {
        const res = await this.$global.server.getWiki(params)
        console.log(res)
        if (res.code == 200) {
          this.wikiInfo = res.data
        }
      } catch (err) {
        console.log(err)
      }
    },
    async getWikiList () {
      const params = {
        type: this.domainConfig['IAmType'],
        pageNum: this.page,
        pageSize: 6,
      };
      if (this.activeTag) {
        params.category = this.activeTag
      }

      try {
        const res = await this.$global.server.getWikiList(params)
        console.log(res)
        if (res.code == 200) {
          let data = res.data.popularizations
          this.wikiList.push(...data)
          this.hasNext = res.data.hasNext
          this.page++;
        }
      } catch (err) {
        console.log(err)
      }
    },
    chooseTag (tag) {
      const currentParams = this.$router.currentRoute.params; // 当前路由的 params
      const currentQuery = this.$route.query; // 当前路由的 query

      const channel = currentParams.channel ? `/${currentParams.channel}` : ''; // 拼接 channel path
      const queryString = new URLSearchParams(currentQuery).toString(); // 转换 query 对象为字符串
      const fullQueryString = queryString ? `?${queryString}` : ''; // 如果有查询参数，拼接为 ?xxx=yyy 格式

      window.location.href = `${channel}/${tag}${fullQueryString}`
    },
    chooseWiki (id, name, cate) {
      console.log(id, name);
      const currentParams = this.$router.currentRoute.params; // 当前路由的 params
      const currentQuery = this.$route.query; // 当前路由的 query

      const channel = currentParams.channel ? `/${currentParams.channel}` : ''; // 拼接 channel path
      const queryString = new URLSearchParams(currentQuery).toString(); // 转换 query 对象为字符串
      const fullQueryString = queryString ? `?${queryString}` : ''; // 如果有查询参数，拼接为 ?xxx=yyy 格式

      window.location.href = `${channel}/${cate.replace(/\s+/g, '-')}/${id}/${name.replace(/\s+/g, '-')}${fullQueryString}`
    },
    // 防抖函数
    debounce (func, delay) {
      let timeout;
      return function (...args) {
        clearTimeout(timeout);
        timeout = setTimeout(() => {
          func.apply(this, args);
        }, delay);
      };
    },
    onScroll () {
      // 获取文档的总高度
      const documentHeight = document.documentElement.scrollHeight;
      // 当前滚动的高度
      const scrollTop = window.scrollY || document.documentElement.scrollTop;
      // 视口的高度
      const windowHeight = window.innerHeight;

      // 在滚动时执行 showPos 方法，获取当前可视范围内的广告坐标
      this.showPos();

      // 当滚动距离接近底部2000px时触发
      if (scrollTop + windowHeight >= documentHeight - 2000) {
        console.log('加载');
        this.getWikiList();
      }
    },
    //广告相关start
    shouldInsertAd (index) {
      // 判断是否应该插入广告的位置
      const position = index + 1;
      const adIndex = this.deviceType == 'mobile' ? this.adPosConfig?.homeRecommand?.indexOf(position) : this.adPosConfig?.homeRecommandPC?.indexOf(position);

      /// 返回广告在 homeAD 中的索引，如果不在配置中则返回 -1
      return adIndex !== -1 && adIndex !== undefined ? adIndex : -1;
    },
    shouldDetailInsertAd (index) {
      // 判断是否应该插入广告的位置
      const position = index + 1;
      const adIndex = this.adPosConfig.detail.indexOf(position);

      /// 返回广告在 homeAD 中的索引，如果不在配置中则返回 -1
      return adIndex !== -1 ? adIndex : -1;
    },
    //广告相关end
    //已被 adMixin 接管

    //ciyi

    goto (name) {
      this.$router.push({ name: name });
    },

    // 显示当前屏幕可视范围内的广告坐标
    showPos () {
      console.log('执行showPos方法，显示当前可视范围内的广告坐标');

      // 获取所有广告元素
      const adElements = document.querySelectorAll('ins.adsbygoogle');
      const visibleAds = [];

      // 当前屏幕可视区域信息
      const windowWidth = window.innerWidth;
      const windowHeight = window.innerHeight;

      // 遍历所有广告元素，找出在可视范围内的
      adElements.forEach((adElement, index) => {
        // 使用 getBoundingClientRect 获取元素相对于视口的位置
        const rect = adElement.getBoundingClientRect();

        // 检查元素是否在视口中可见（至少部分可见）
        // rect.top 和 rect.left 是相对于视口左上角的坐标
        const isVisible = !(
          rect.bottom < 0 ||   // 元素底部在视口顶部以上
          rect.top > windowHeight ||  // 元素顶部在视口底部以下
          rect.right < 0 ||  // 元素右侧在视口左侧以外
          rect.left > windowWidth  // 元素左侧在视口右侧以外
        );

        if (isVisible) {
          // 保持与 setupIframeTracking 方法中相同的数据格式
          const transformData = {
            insX: Math.round(rect.left),
            insY: Math.round(rect.top),
            insHeight: Math.round(rect.height),
            windowWidth: windowWidth,
            windowHeight: windowHeight
          };

          visibleAds.push(transformData);
          console.log(`可视广告 #${index}:`, transformData);
        }
      });

      console.log('可视范围内的广告数量:', visibleAds.length);
      console.log('可视范围内的广告坐标:', visibleAds);

      // 即使没有可见广告，也会发送空数组
      this.$adPosition(JSON.stringify(visibleAds))
      return visibleAds;
    },

    // 计算元素在视口中的可见比例
    calculateVisibility (rect, windowWidth, windowHeight) {
      // 计算元素在视口内可见部分的面积
      const visibleWidth = Math.min(rect.right, windowWidth) - Math.max(rect.left, 0);
      const visibleHeight = Math.min(rect.bottom, windowHeight) - Math.max(rect.top, 0);

      if (visibleWidth <= 0 || visibleHeight <= 0) return 0;

      // 元素的总面积
      const totalArea = rect.width * rect.height;
      // 可见面积
      const visibleArea = visibleWidth * visibleHeight;

      // 返回百分比，四舍五入到整数
      return Math.round((visibleArea / totalArea) * 100);
    },

  }
};
</script>
